// extracted by mini-css-extract-plugin
module.exports = {"wr6mma6":"wr6mma6","t1r760p6":"t1r760p6","t1qfwu6x":"t1qfwu6x","i1r82ncc":"i1r82ncc"};